export default __webpack_public_path__ + "static/media/img-0179-spain-premium-face.fb2aaf7e.png";